import { Temporal } from '@js-temporal/polyfill';
import { useCallback, useState } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { RotatingWrapper } from 'src/core/ui/AnimatingWrapper';
import { DefaultMarketplacePaymentQuery } from 'src/navigations/Routes/Payments/Payments.constants';
import { ProcessingIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { downloadFileFromBlob } from 'src/utils/fileUtils';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import { MarketplacePaymentClient } from 'src/WebApiController';

export const ExportPaymentAction = ({
  firstOfMonth,
}: {
  firstOfMonth: string;
}) => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();
  const [isLoading, setIsLoading] = useState(false);

  const onExportButtonClicked = useCallback(async () => {
    setIsLoading(true);

    const firstOfMonthPlainDateTime = Temporal.PlainDateTime.from(firstOfMonth);
    const lastOfMonthPlainDateTime = firstOfMonthPlainDateTime
      .with({
        day: firstOfMonthPlainDateTime.daysInMonth,
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 999,
      })
      .toString();

    await tryInvokeApi(
      async () => {
        const result = await new MarketplacePaymentClient(
          activeAccountWebClientConfig
        ).exportPayments({
          ...DefaultMarketplacePaymentQuery,
          paymentDates: {
            ...DefaultMarketplacePaymentQuery.paymentDates,
            start: firstOfMonth,
            end: lastOfMonthPlainDateTime,
          },
        });

        if (result.data) {
          downloadFileFromBlob(result.fileName ?? 'payments.csv', result.data);
        }
      },
      (error) => {
        showErrorDialog('MarketplacePaymentClient.exportPayments', error, {
          trackErrorData: { firstOfMonth },
        });
      },
      () => setIsLoading(false)
    );
  }, [activeAccountWebClientConfig, firstOfMonth, showErrorDialog]);

  return (
    <PosDropdownItem
      keepOpenAfterSelection
      onClick={(e) => {
        e.stopPropagation();
        onExportButtonClicked();
      }}
    >
      {isLoading && (
        <RotatingWrapper>
          <ProcessingIcon />
        </RotatingWrapper>
      )}
      <Content id={ContentId.DownloadCSV} />
    </PosDropdownItem>
  );
};
